export const BACKEND_API_BASE_URL = process.env.REACT_APP_BACKEND_API_BASE_URL || 'http://localhost:3030/v1';
export const ADYEN_ENV = process.env.REACT_APP_ADYEN_ENV || 'test';
export const ADYEN_ORIGIN_KEY = process.env.REACT_APP_ADYEN_ORIGIN_KEY || '';
